var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeartCardTrending = function SvgIconHeartCardTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F0F2FA",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M14.644 11.512a3.062 3.062 0 0 0-4.393 0 3.245 3.245 0 0 0 0 4.522l5.154 5.253a.833.833 0 0 0 1.19 0l5.154-5.253a3.245 3.245 0 0 0 0-4.522 3.062 3.062 0 0 0-4.393 0l-.761.776a.833.833 0 0 1-1.19 0l-.761-.776Zm1.19-1.168.166.17.166-.17a4.729 4.729 0 0 1 6.773 0 4.911 4.911 0 0 1 0 6.857l-5.154 5.253a2.5 2.5 0 0 1-3.57 0l-5.154-5.253a4.911 4.911 0 0 1 0-6.857 4.729 4.729 0 0 1 6.773 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeartCardTrending;